import { IAggregate } from '../Aggregate/types';

export interface ILight extends IAggregate {
    
}

export const schema = 'AutomationApps.Devices.Lights.Light';
export const modelId = 'dtmi:AutomationApps:Devices:Lights:Light';